export enum EPrefilledEmaiActionTypes {
  EmailSet = 'IPrefilledEmailSet',
  EmailReset = 'IPrefilledEmailReset',
}

export interface IPrefilledEmailSet {
  type: EPrefilledEmaiActionTypes.EmailSet;
  prefilledEmail: string;
}

export interface IPrefilledEmailReset {
  type: EPrefilledEmaiActionTypes.EmailReset;
}

export type TPrefilledEmailActions = IPrefilledEmailSet | IPrefilledEmailReset;

export const setPrefilledEmail = (prefilledEmail: string): IPrefilledEmailSet => ({
  type: EPrefilledEmaiActionTypes.EmailSet,
  prefilledEmail,
});

export const resetPrefilledEmail = (): IPrefilledEmailReset => ({
  type: EPrefilledEmaiActionTypes.EmailReset,
});
